module.exports = __webpack_public_path__ + "img/ps-logo-new.3c467493.svg";